/**
 * 画面下の常設操作ガイドバーの文言決定 — 純粋JS（DOM / three.js 非依存、
 * node でテスト可能）。状況コンテキストを受け取り、表示すべき1行テキストを
 * 返す。空文字 '' はバー非表示（勝利バナー表示中など）。
 *
 * 優先度（上ほど強い）:
 *   0. チュートリアル  → tutorialText（現在ステップの instruction）をそのまま表示
 *   1. 勝敗確定        → ''（勝利バナーに委ねる）
 *   2. CPU手番         → 'CPU思考中…'（一時停止中は '一時停止中'）
 *   3. 壁プレビュー中  → タッチ2段階確定の操作案内
 *   4. 能力モード中    → 対象タップの案内（removeWall は壁、他はマス）
 *   5. 沼で移動不可    → 壁は置ける旨の案内
 *   6. 通常（人間手番）→ 基本操作。coarse=タッチ系 / fine=マウス系で出し分け
 */
export function guideMessage({
  tutorialText = null,
  winner = null,
  cpuTurn = false,
  cpuPaused = false,
  wallPreview = false,
  abilityMode = false,
  abilityKind = null,
  swamped = false,
  coarse = false,
} = {}) {
  if (tutorialText) return tutorialText; // チュートリアル文言が最優先
  if (winner !== null && winner !== undefined) return '';
  if (cpuTurn) return cpuPaused ? '一時停止中' : 'CPU思考中…';
  if (wallPreview) return 'もう一度タップで設置 ／ ✕でやめる';
  if (abilityMode) {
    return abilityKind === 'removeWall'
      ? '除去する壁をタップ ／ Escで解除'
      : '対象のマスをタップ ／ Escで解除';
  }
  if (swamped) return '沼: このターンは移動できません（壁は置けます）';
  return coarse
    ? '緑のマスをタップで移動 ／ ミゾをタップで壁 ／ 2本指で視点回転'
    : '緑のマスをクリックで移動 ／ ミゾにポインタで壁プレビュー ／ ドラッグで視点回転';
}
